export default __webpack_public_path__ + "static/media/image.9bdfd016.svg";